// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","section":"App_section__jwu5t","toast":"App_toast__Mt+5G"};